document.addEventListener("DOMContentLoaded", () => {
    const fixedLivePreview = () => {
        const galleryWrapperSelector = ".grid__item.product__media-wrapper";
        const $gallery = document.querySelector(galleryWrapperSelector);

        if (!$gallery) {
            return;
        }

        const style = document.createElement("style");
        style.innerHTML = `
            /* Original Sticky Styles - bleiben unverändert */
            .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery-content {
                background: #fff;
                box-shadow: 0 2px 5px 3px rgba(0, 0, 0, .15);
                display: flex;
                justify-content: center;
                left: 0;
                position: fixed;
                top: env(safe-area-inset-top, 0);
                width: calc(100vw);
                z-index: 99;
            }

            .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery {
                width: auto;
                zoom: .7;
            }

            .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-thumbnails,
            .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-slider__dots {
                display: none;
            }

            .gallery--sticky:not(.gallery--sticky--hide) .gallery--close-button {
                display: block;
            }

            .gallery--sticky.gallery--sticky--hide .sticky-gallery-button {
                display: block;
            }

            /* Neuer dauerhafter Vorschau-Button – rund & in der neuen Farbe */
            .preview-popup-button {
                position: fixed !important;
                right: 15px !important;
                top: 50% !important;
                transform: translateY(-50%) !important;
                width: 56px !important;
                height: 56px !important;
                border-radius: 50% !important;
                padding: 0 !important;
                background: #a4cdbf !important;
                color: #fff !important;
                border: none !important;
                box-shadow: 0 6px 20px rgba(164, 205, 191, 0.45) !important;
                z-index: 9998 !important;
                cursor: pointer !important;
                transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                gap: 0 !important;
                min-width: 56px !important;
                writing-mode: horizontal-tb !important;
                font-size: 0 !important;
            }

            .preview-popup-button:hover {
                transform: translateY(-50%) scale(1.06) !important;
                box-shadow: 0 10px 28px rgba(164, 205, 191, 0.55) !important;
                background: #92c2b0 !important;
            }

            .preview-popup-button:active {
                transform: translateY(-50%) scale(0.95) !important;
            }

            /* Icon - größeres Auge */
            .preview-popup-button .icon {
                width: 32px !important;
                height: 32px !important;
                background-image: url('https://cdn.shopify.com/s/files/1/0912/3456/6530/files/eye.png?v=1758041071') !important;
                background-size: contain !important;
                background-repeat: no-repeat !important;
                background-position: center !important;
                filter: brightness(0) invert(1) !important;
                display: inline-block !important;
            }

            /* Entferne die alten CSS-Eye-Styles */
            .preview-popup-button .icon::before,
            .preview-popup-button .icon::after {
                display: none !important;
            }

            /* Popup Overlay Styles */
            .gallery-popup-overlay {
                position: fixed !important;
                top: 0 !important;
                left: 0 !important;
                right: 0 !important;
                bottom: 0 !important;
                background: rgba(0, 0, 0, 0.85) !important;
                z-index: 99999 !important;
                display: none !important;
                align-items: center !important;
                justify-content: center !important;
                padding: 15px !important;
            }

            .gallery-popup-overlay.active {
                display: flex !important;
            }

            .gallery-popup-content {
                background: white !important;
                border-radius: 16px !important;
                max-width: 90vw !important;
                max-height: 85vh !important;
                overflow: hidden !important;
                position: relative !important;
                box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5) !important;
                animation: popupScale 0.3s ease-out !important;
                display: flex !important;
                flex-direction: column !important;
            }

            @keyframes popupScale {
                from {
                    transform: scale(0.7);
                    opacity: 0;
                }
                to {
                    transform: scale(1);
                    opacity: 1;
                }
            }

            .gallery-popup-header {
                background: #b4aba2 !important;
                color: white !important;
                padding: 12px 20px !important;
                display: flex !important;
                justify-content: space-between !important;
                align-items: center !important;
                flex-shrink: 0 !important;
            }

            .gallery-popup-title {
                font-size: 16px !important;
                font-weight: 600 !important;
                margin: 0 !important;
                color: white !important;
            }

            .gallery-popup-close {
                background: rgba(255, 255, 255, 0.2) !important;
                border: none !important;
                color: white !important;
                width: 32px !important;
                height: 32px !important;
                border-radius: 50% !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                cursor: pointer !important;
                font-size: 18px !important;
                font-weight: bold !important;
                transition: background 0.2s ease !important;
            }

            .gallery-popup-close:hover {
                background: rgba(255, 255, 255, 0.3) !important;
            }

            .gallery-popup-body {
                padding: 20px !important;
                display: flex !important;
                justify-content: center !important;
                align-items: center !important;
                flex: 1 !important;
                min-height: 200px !important;
                max-height: calc(85vh - 60px) !important;
                overflow: hidden !important;
            }

            .gallery-popup-body .tee-gallery {
                zoom: 0.8 !important;
                width: auto !important;
                max-width: 100% !important;
                max-height: 100% !important;
                object-fit: contain !important;
            }

            .gallery-popup-body .tee-gallery img {
                max-width: 100% !important;
                max-height: 100% !important;
                object-fit: contain !important;
                width: auto !important;
                height: auto !important;
            }

            .gallery-popup-body .tee-thumbnails,
            .gallery-popup-body .tee-slider__dots {
                display: none !important;
            }

            .gallery-popup-body .gallery--close-button,
            .gallery-popup-body [class*="close"],
            .gallery-popup-body [class*="Close"] {
                display: none !important;
            }

            .sticky-gallery-button {
                background-color: #fff;
                background-image: url('data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><g><path d="M114.5,79.1C95,79.1,79.1,95,79.1,114.5v283c0,19.5,15.8,35.4,35.4,35.4h283c19.5,0,35.4-15.8,35.4-35.4v-283 c0-19.5-15.8-35.4-35.4-35.4H114.5z M114.5,409.3c-6.5,0-11.8-5.3-11.8-11.8V308l94.3-94.3l195.6,195.6H114.5z M409.3,392.7 L331.6,315l30.5-30.5l47.2,47.2V392.7z M409.3,114.5v183.8l-38.8-38.9c-4.6-4.6-12.1-4.7-16.7-0.1c0,0,0,0-0.1,0.1L315,298.3 L205.4,188.7c-4.6-4.6-12.1-4.7-16.7-0.1c0,0,0,0-0.1,0.1l-86,86.1V114.5c0-6.5,5.3-11.8,11.8-11.8h283 C404,102.7,409.3,108,409.3,114.5z"/></g></svg>');
                background-position: center;
                background-repeat: no-repeat;
                background-size: 20px 20px;
                border-radius: 50%;
                box-shadow: 0px 0px 5px;
                display: none;
                height: 40px;
                position: fixed;
                right: 20px;
                top: 100px;
                width: 40px;
                z-index: 999;
            }

            /* Spezifischer Selektor nur für das Sticky-Fenster X */
            .gallery--sticky:not(.gallery--sticky--hide) .gallery--close-button {
                position: absolute !important;
                top: 8px !important;
                right: 12px !important;
                width: 32px !important;
                height: 32px !important;
                background: rgba(0, 0, 0, 0.7) !important;
                color: white !important;
                border: none !important;
                border-radius: 50% !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                cursor: pointer !important;
                font-size: 18px !important;
                font-weight: bold !important;
                line-height: 1 !important;
                text-align: center !important;
                z-index: 1000 !important;
                transition: all 0.2s ease !important;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
            }

            .gallery--sticky:not(.gallery--sticky--hide) .gallery--close-button:hover {
                background: rgba(0, 0, 0, 0.9) !important;
                transform: scale(1.1) !important;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4) !important;
            }

            .gallery--sticky:not(.gallery--sticky--hide) .gallery--close-button:active {
                transform: scale(0.95) !important;
            }

            /* X-Symbol nur für Sticky-Fenster */
            .gallery--sticky:not(.gallery--sticky--hide) .gallery--close-button::before {
                content: '×' !important;
                display: block !important;
                font-size: 20px !important;
                font-weight: bold !important;
                line-height: 1 !important;
            }

            /* Verstecke alle anderen Close-Buttons im normalen Zustand */
            .gallery--close-button:not(.gallery--sticky .gallery--close-button) {
                display: none !important;
            }

            body.popup-open {
                overflow: hidden !important;
                position: fixed !important;
                width: 100% !important;
                height: 100% !important;
            }
        `;
        document.head.appendChild(style);

        let hasStickyButton = false;
        let hasCloseButton = false;
        let hasPreviewButton = false;
        let popupOverlay = null;
        let savedScrollPosition = 0;
        let wasAutoClosedByModal = false; // Merkt sich, ob Sticky automatisch geschlossen wurde
        let currentOpenModal = null; // Referenz zum aktuell offenen Modal

        // Prüfe ob ein Modal aktuell offen ist
        const checkForOpenModal = () => {
            const modalSelectors = [
                '[role="dialog"]',
                '.modal',
                '.Modal',
                '.dialog',
                '.Dialog',
                '.tee-modal',
                '.tee-dialog',
                '[class*="tee-modal"]',
                '[class*="tee-dialog"]'
            ];

            for (const selector of modalSelectors) {
                const modals = document.querySelectorAll(selector);
                for (const modal of modals) {
                    if (modal.classList.contains('gallery-popup-overlay')) {
                        continue;
                    }

                    const styles = window.getComputedStyle(modal);
                    const rect = modal.getBoundingClientRect();
                    
                    if (styles.display !== 'none' && 
                        styles.visibility !== 'hidden' && 
                        parseFloat(styles.opacity) > 0.1 &&
                        rect.width > 0 && 
                        rect.height > 0) {
                        
                        const zIndex = parseInt(styles.zIndex) || 0;
                        if (zIndex >= 100) {
                            return modal;
                        }
                    }
                }
            }
            return null;
        };

        // Funktion zum automatischen Schließen des Sticky-Fensters
        const closeStickyIfModalOpen = () => {
            // Prüfe erst, ob das Sticky-Fenster überhaupt offen ist
            if (!document.body.classList.contains('gallery--sticky') || 
                document.body.classList.contains('gallery--sticky--hide')) {
                return;
            }

            const openModal = checkForOpenModal();
            
            if (openModal) {
                // Modal ist offen - schließe Sticky
                currentOpenModal = openModal;
                wasAutoClosedByModal = true;
                document.body.classList.add('gallery--sticky--hide');
                $gallery.style.removeProperty('height');
            }
        };

        // Funktion zum automatischen Wiederöffnen des Sticky-Fensters
        const reopenStickyIfModalClosed = () => {
            // Nur wiederöffnen wenn:
            // 1. Es wurde automatisch durch ein Modal geschlossen
            // 2. Kein Modal ist mehr offen
            // 3. Die Scroll-Position würde das Sticky anzeigen
            if (!wasAutoClosedByModal) {
                return;
            }

            const openModal = checkForOpenModal();
            
            if (!openModal && currentOpenModal) {
                // Modal wurde geschlossen - prüfe ob Sticky wieder angezeigt werden soll
                const galleryTop = $gallery.getBoundingClientRect().top;
                const tFormElement = document.getElementById("tee-artwork-form");
                
                if (tFormElement) {
                    const tFormBottom = tFormElement.getBoundingClientRect().bottom;
                    const galleryContentElement = document.querySelector(".tee-gallery-content");
                    
                    if (galleryContentElement) {
                        const galleryContentHeight = galleryContentElement.offsetHeight;
                        
                        // Wenn die Scroll-Position passt, öffne Sticky wieder
                        if (galleryTop < -10 && tFormBottom > galleryContentHeight) {
                            document.body.classList.remove('gallery--sticky--hide');
                            $gallery.style.height = `${galleryContentHeight + 10}px`;
                        }
                    }
                }
                
                // Reset der Flags
                wasAutoClosedByModal = false;
                currentOpenModal = null;
            }
        };

        // MutationObserver um neue Modals zu erkennen und geschlossene zu überwachen
        const modalObserver = new MutationObserver((mutations) => {
            let shouldCheck = false;

            mutations.forEach((mutation) => {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1) {
                            const el = node;
                            if (el.classList && (
                                el.classList.contains('modal') ||
                                el.classList.contains('Modal') ||
                                el.classList.contains('dialog') ||
                                el.classList.contains('Dialog') ||
                                el.hasAttribute('role') && el.getAttribute('role') === 'dialog' ||
                                el.className.includes('modal') ||
                                el.className.includes('Modal') ||
                                el.className.includes('dialog') ||
                                el.className.includes('Dialog') ||
                                el.className.includes('tee-modal') ||
                                el.className.includes('tee-dialog')
                            )) {
                                shouldCheck = true;
                            }
                        }
                    });
                }
                
                // Auch bei entfernten Nodes prüfen (Modal wurde geschlossen)
                if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
                    mutation.removedNodes.forEach(node => {
                        if (node === currentOpenModal) {
                            shouldCheck = true;
                        }
                    });
                }
                
                if (mutation.type === 'attributes') {
                    const target = mutation.target;
                    if (target.nodeType === 1) {
                        const el = target;
                        if (el.classList && (
                            el.classList.contains('modal') ||
                            el.classList.contains('Modal') ||
                            el.classList.contains('dialog') ||
                            el.classList.contains('Dialog') ||
                            el.hasAttribute('role') && el.getAttribute('role') === 'dialog' ||
                            el.className.includes('modal') ||
                            el.className.includes('Modal') ||
                            el.className.includes('dialog') ||
                            el.className.includes('Dialog') ||
                            el.className.includes('tee-modal') ||
                            el.className.includes('tee-dialog')
                        )) {
                            shouldCheck = true;
                        }
                    }
                }
            });

            if (shouldCheck) {
                setTimeout(() => {
                    closeStickyIfModalOpen();
                    reopenStickyIfModalClosed();
                }, 100);
            }
        });

        modalObserver.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
        });

        const createPopup = () => {
            const popup = document.createElement('div');
            popup.className = 'gallery-popup-overlay';
            popup.innerHTML = `
                <div class="gallery-popup-content">
                    <div class="gallery-popup-header">
                        <h3 class="gallery-popup-title">Produktvorschau</h3>
                        <button class="gallery-popup-close" onclick="closeGalleryPopup()">×</button>
                    </div>
                    <div class="gallery-popup-body">
                        <div class="loading">Wird geladen...</div>
                    </div>
                </div>
            `;

            popup.addEventListener('click', (e) => {
                if (e.target === popup) {
                    closeGalleryPopup();
                }
            });

            return popup;
        };

        const updatePopupContent = () => {
            if (!popupOverlay) return;

            const $teeGallery = document.querySelector(`${galleryWrapperSelector} #tee-gallery`);
            const popupBody = popupOverlay.querySelector('.gallery-popup-body');

            if ($teeGallery && popupBody) {
                const galleryClone = $teeGallery.cloneNode(true);
                galleryClone.style.position = 'static';
                galleryClone.style.transform = 'none';

                const closeButtons = galleryClone.querySelectorAll('.gallery--close-button, [class*="close"], [class*="Close"]');
                closeButtons.forEach(btn => btn.remove());

                popupBody.innerHTML = '';
                popupBody.appendChild(galleryClone);
            }
        };

        const openGalleryPopup = () => {
            savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            document.body.style.top = `-${savedScrollPosition}px`;

            if (!popupOverlay) {
                popupOverlay = createPopup();
                document.body.appendChild(popupOverlay);
            }

            updatePopupContent();
            popupOverlay.classList.add('active');
            document.body.classList.add('popup-open');
        };

        const closeGalleryPopup = () => {
            if (popupOverlay) {
                popupOverlay.classList.remove('active');
                document.body.classList.remove('popup-open');
                document.body.style.top = '';
                window.scrollTo(0, savedScrollPosition);
            }
        };

        window.closeGalleryPopup = closeGalleryPopup;

        const createPreviewButton = () => {
            if (hasPreviewButton) return;

            const previewButton = document.createElement('button');
            previewButton.className = 'preview-popup-button';
            previewButton.innerHTML = '<span class="icon"></span>';
            previewButton.title = 'Produktvorschau anzeigen';

            previewButton.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                openGalleryPopup();
            });

            document.body.appendChild(previewButton);
            hasPreviewButton = true;
        };

        const onScroll = () => {
            const $teeGallery = document.querySelector(`${galleryWrapperSelector} #tee-gallery`);

            if ($teeGallery) {
                if (!hasStickyButton) {
                    const stickyButton = document.createElement("div");
                    stickyButton.className = "sticky-gallery-button";
                    stickyButton.addEventListener("click", (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        // Bei manuellem Öffnen Flag zurücksetzen
                        wasAutoClosedByModal = false;
                        currentOpenModal = null;
                        document.body.classList.remove("gallery--sticky--hide");
                        const galleryContentHeight = document.querySelector(".tee-gallery-content").offsetHeight;
                        $gallery.style.height = `${galleryContentHeight + 10}px`;
                    });
                    document.body.appendChild(stickyButton);
                    hasStickyButton = true;
                }

                if (!hasCloseButton) {
                    const closeButton = document.createElement("div");
                    closeButton.className = "gallery--close-button";
                    closeButton.addEventListener("click", (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        // Bei manuellem Schließen Flag zurücksetzen
                        wasAutoClosedByModal = false;
                        currentOpenModal = null;
                        document.body.classList.add("gallery--sticky--hide");
                        $gallery.style.removeProperty("height");
                    });
                    $teeGallery.appendChild(closeButton);
                    hasCloseButton = true;
                }

                if (!hasPreviewButton) {
                    createPreviewButton();
                }

                const galleryTop = $gallery.getBoundingClientRect().top;
                const tFormBottom = document.getElementById("tee-artwork-form").getBoundingClientRect().bottom;
                const galleryContentHeight = document.querySelector(".tee-gallery-content").offsetHeight;

                if (galleryTop < -10 && tFormBottom > galleryContentHeight) {
                    document.body.classList.add("gallery--sticky");
                    $gallery.style.height = `${galleryContentHeight + 10}px`;
                } else {
                    document.body.classList.remove("gallery--sticky");
                    $gallery.style.removeProperty("height");
                }
            }
        };

        const $window = window;
        $window.addEventListener("scroll", onScroll);
        $window.addEventListener("DOMMouseScroll", onScroll);
    };

    const w = window.innerWidth;
    const h = window.innerHeight;

    if (h / w > 1.5 && w < 768) {
        setTimeout(function () {
            fixedLivePreview();
        }, 2000);
    }
});